import { useMemo } from 'react'
import { useMediaQuery, useTheme } from '@mui/material'
import useFavurTranslation from 'hooks/useFavurTranslation'
import type { TextBlockData } from 'shared/graphql/graphql'
import type { UseAnnouncementDialogT, ButtonDetails } from './types'
import { getOrderedBlocks, getTextFromHTML, separateBlocks } from './utils'

export const useAnnouncementDialog = ({ blocks = [] }: UseAnnouncementDialogT) => {
  const { breakpoints } = useTheme()
  const isSmallScreen = useMediaQuery(breakpoints.down('sm'))
  const { language } = useFavurTranslation()
  const orderedBlocks = useMemo(() => getOrderedBlocks(blocks, language), [blocks, language])
  const { firstBlock, lastBlock, remainingBlocks } = separateBlocks(orderedBlocks)
  const headerTitle = useMemo(() => getTextFromHTML((firstBlock?.data as TextBlockData)?.html ?? ''), [firstBlock])

  return { isSmallScreen, headerTitle, orderedBlocks: remainingBlocks, buttonDetails: lastBlock?.data as ButtonDetails }
}
